export default __webpack_public_path__ + "static/media/carousel-slide-3.e202ae5f.jpg";